import * as React from 'react';
import { getColorValue } from '../utilities/color';

function Picture1(props) {
  const orange = getColorValue('illustrationOrange');
  const blue = getColorValue('illustrationAccent');
  const green = getColorValue('illustrationGreen');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m32 221.649s139.28 16.56 210.96-.75v-172.39s-113.67 27.85-210.96-1.51c0 0 1.54 175.77 0 174.64z"
        fill={orange}
      />
      <path
        d="m56.8301 205.159s106.4899 12.66 161.3099-.58v-131.8001s-86.92 21.3-161.3099-1.15c0 0 1.17 134.4001 0 133.5301z"
        fill={blue}
      />
      <path
        d="m67.5798 206.299v-131.7501c-3.6-.88-7.19-1.85-10.74-2.92 0 0 1.17 134.4001 0 133.5301 0 0 3.97.47 10.74 1.14z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m218.14 204.579v-37.22l-2-1.89c-11.12-10.55-28.56-10.55-39.68 0-12.73 12.08-33.21 10.07-43.36-4.25l-18.23-25.72c-11.49-16.21-35.5499-16.21-47.0399 0l-10.52 14.85c.09 29.17.03 55.19-.48 54.81 0 0 106.4899 12.66 161.3099-.58z"
        fill={green}
      />
      <path
        d="m175.86 129.689c.21-1.18.32-2.44.32-3.77s-.11-2.62-.33-3.82c-1.28-7.13-6.23-11.52-13.17-12.65-1.18-.19-2.43-.29-3.72-.29s-2.64.11-3.87.31c-6.95 1.16-11.89 5.54-13.17 12.63-.22 1.2-.33 2.47-.33 3.82s.11 2.59.32 3.77c1.27 7.08 6.22 11.47 13.18 12.63 1.23.21 2.52.31 3.87.31s2.53-.1 3.72-.29c6.95-1.13 11.91-5.53 13.18-12.65z"
        fill={orange}
      />
      <path
        d="m67.5798 135.869-10.26 14.48c.09 29.17.03 55.19-.48 54.81 0 0 3.97.47 10.74 1.14v-70.42z"
        fill={blue}
      />
    </svg>
  );
}

export default Picture1;
